// pharmacy-sso-error.component.ts
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MultilingualService, TokenService } from '@core/services';
import { AppConstants } from '@root/app/app.constants';
import { SetImagePathDirective } from '@shared/directives';
import { AppCenterAnalytics, AppInsightsService, CryptoAesCbcService } from '@shared/services';
@Component({
  selector: 'app-pharmacy-sso-error',
  standalone: true,
  templateUrl: './pharmacy-sso-error.component.html',
  styleUrl: './pharmacy-sso-error.component.scss',
  imports: [SetImagePathDirective]
})
export class PharmacySsoErrorComponent implements OnInit {
  public error = '';

  public memberDetails: {
    clientID: string;
    CardID: string;
    personCode: string;
  } = {
      clientID: '',
      CardID: '',
      personCode: ''
    };

  constructor(
    private readonly route: ActivatedRoute,
    private readonly cryptoSvc: CryptoAesCbcService,
    private readonly appInsightsService: AppInsightsService,
    private readonly tokenService: TokenService,
    private readonly multilingualService: MultilingualService
  ) { }

  async ngOnInit(): Promise<void> {
    try {
      // ✅ Read from query params (NOT fragment)
      const qp = this.route.snapshot.queryParamMap;
      const encryptedData = qp.get('data');
      const userMessage = qp.get('msg');
      this.error = userMessage? userMessage: this.multilingualService.langMap.ERROR_COMMON_SOMETHING_WENT_WRONG;
      

      if (!encryptedData) {
        return; // nothing to decrypt
      }

      // ✅ Your AES key (must match backend)
      const keyB64 = AppConstants.AES_KEY_B64;
      const cryptoKey = await this.cryptoSvc.importAesCbcKeyFromBase64(keyB64);

      console.debug('Received encrypted data:', encryptedData, 'cryptoKey:', cryptoKey);
      // ✅ Decrypt and parse JSON (must match backend’s JSON payload)
      const json = await this.cryptoSvc.decryptBase64IvCipher(encryptedData, cryptoKey);
      console.debug('Decrypted JSON string:', json);
      const memberContext = JSON.parse(json);

      console.debug('Decrypted member context:', memberContext);

      // ✅ Map to your view model (adjust property names if backend differs)
      this.memberDetails = {
        clientID: memberContext.clientId ?? '',
        CardID: memberContext.cardId ?? '',
        personCode: memberContext.personCode ?? ''
      };
      this.appInsightsService.trackPageViewWithoutClientId(`${AppCenterAnalytics.PHARMACY_SSO_REDIRECTION_ERROR_PAGE_VIEWED}`, this.getProperties());
    } catch (err) {
      console.error('SSO error page decryption failed:', err);
      this.error ||= 'Unable to process the secure payload.';
    }
  }

  private getProperties(): {
    clientID: string;
    CardID: string;
    Platform: string;
    data: { personCode: string };
  } {
    return {
      clientID: this.memberDetails.clientID,
      CardID: this.memberDetails.CardID,
      Platform: this.tokenService.ssoToken || this.tokenService.azureIdToken ? 'web' : 'mobile',
      data: { personCode: this.memberDetails.personCode },
    }
  }
}